<gh-generic-sub-navigation [options]="options" [itemsType]="'kpis'" [recent]="getRecent()"></gh-generic-sub-navigation>
